<template>
  <div class="ranking-scroll">
    <div class="ranking-wrapper">
      <div class="banner">
        <img src="../../assets/ranking/banner_rank.png" />
        <div class="view-rule" @click="viewRule">查看规则>></div>
      </div>
      <div class="tabbar">
        <div class="triangle" :style="`transform: translateX(${triX}px)`"></div>
        <div :class="activeTab === 1 ? 'items action' : 'items'" @click="hangdClickTab(1)">发帖排行榜</div>
        <div :class="activeTab === 2 ? 'items action' : 'items'" @click="hangdClickTab(2)">积分排行榜</div>
      </div>
      <dynamic-item
        ref="dynamic"
        :tab='activeTab'
      />
    </div>
  </div>
</template>

<script>
// 积分排行榜
import DynamicItem from './Dynamic'
export default {
  name: 'RankingList',
  components: { DynamicItem },
  data () {
    return {
      winWidth: 0,
      winHeight: document.documentElement.clientHeight,
      triX: 0,
      activeTab: 1
    }
  },
  created () {
    const { type } = this.$route.query
    if (Number(type) === 2) {
      this.activeTab = Number(type)
    }
    this.winWidth = document.body.offsetWidth
    this.triX = parseInt((this.winWidth / 2 - 12) / 2)
  },
  methods: {
    // 查看规则页面
    viewRule () {
      this.$router.push('/rankingrule')
    },
    // 发帖/积分 tab切换
    hangdClickTab (index) {
      if (index === 1 && this.activeTab !== 1) {
        this.$router.replace('/rankinglist')
        this.triX = parseInt((this.winWidth / 2 - 12) / 2)
      }
      if (index === 2 && this.activeTab !== 2) {
        this.$router.replace('/rankinglist?type=2')
        const width = parseInt((this.winWidth / 2 - 12) / 2) + (this.winWidth / 2)
        this.triX = parseInt(width)
      }
      this.activeTab = index
    }
  },
  watch: {
    activeTab (val) {
      if (val === 2) {
        this.triX = parseInt((this.winWidth / 2 - 12) / 2) + (this.winWidth / 2)
      }
    }
  }
}
</script>
<style lang="less">
@baseColor: #3257FF;
@white: #ffffff;
html, body, #app {
  height: 100%;
}
.ranking-scroll{
  height: 100%;
  overflow: hidden;
}
.ranking-scroll{
  transform: rotate(0deg);
  position: relative;
}
.ranking-wrapper{
  .view-rule{
    padding: 10px 10px 10px 16px;
    background-color: transparent;
    position: absolute;
    bottom: 23.5px;
    z-index: 2;
    color: #fff;
    font-size: 13px;
  }
  .banner{
    position: relative;
    img{
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .tabbar{
    display:flex;
    position: relative;
    background: @baseColor;
    .triangle{
      position: absolute;
      bottom: 0;
      display: block;
      width: 0;
      height: 0;
      border-width: 6px;
      border-style:solid;
      border-color: transparent transparent @white;
      transition: transform .3s cubic-bezier(.645, .045, .355, 1);
    }
    .items{
      flex: 1;
      padding: 15px 0px;
      box-sizing: border-box;
      height: 50px;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
      text-align: center;
      &.action{
        font-size: 15px;
        font-weight: bold;
        color: @white;
      }
    }
  }
}
</style>
